import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./KlyzenPawtner.css";

function KlyzenPawtner() {
  const highlights = [
    { icon: "🐾", text: "Experienced & Loving Staff" },
    { icon: "🛁", text: "Premium Grooming Products" },
    { icon: "🧼", text: "Safe & Hygienic Environment" },
    { icon: "💖", text: "Personalized Care for Every Pet" },
    { icon: "🚶‍♂️", text: "Reliable Pet Walking & Care Plans" },
  ];

  const groomingServices = [
    {
      name: "Full Service",
      description:
        "Bath with Shampoo & Conditioner, Blow Dry, Full Body Trimming/Zero Haircut, Eye Cleaning, Ear Cleaning, Body Massage, Sanitary Clipping, Nail Clipping, Teeth Cleaning, Paw Massage, Combing/Brushing",
      price: "₹1699 / Visit",
      discounted: "Offer Price: ₹1399",
    },
    {
      name: "Spa Bath",
      description:
        "Bath with Shampoo & Conditioner, Blow Dry, Nail Clipping, Ear Cleaning, Eyes Cleaning, Paw Massage, Combing/Brushing",
      price: "₹1199 / Visit",
      discounted: "Offer Price: ₹899",
    },
    {
      name: "Full Trans-fur-mation",
      description:
        "Full Body Trimming, Ear Cleaning, Eyes Cleaning, Nail Clipping",
      price: "₹1299 / Visit",
      discounted: "Offer Price: ₹999",
    },
  ];

  const walkingServices = [
    {
      name: "1 Time Walk a Day (25 min)",
      pricing: [
        { duration: "1 Month", price: "₹4799", discounted: "₹4399" },
        { duration: "15 Days", price: "₹3199", discounted: "₹2899" },
        { duration: "7 Days", price: "₹2199", discounted: "₹1999" },
      ],
    },
    {
      name: "2 Time Walk a Day (25 min)",
      pricing: [
        { duration: "1 Month", price: "₹8199", discounted: "₹7799" },
        { duration: "15 Days", price: "₹4899", discounted: "₹4699" },
        { duration: "7 Days", price: "₹3299", discounted: "₹2899" },
      ],
    },
  ];

  return (
    <>
      <Navbar />

      {/* HERO */}
      <section className="pawtner-hero">
        <div className="pawtner-overlay" />
        <div className="pawtner-hero-content">
          <h1>Klyzen Pawtner</h1>
          <h2>Premium Pet Care & Grooming</h2>
          <p>
            We provide professional, loving, and personalized services for
            your furry friends — grooming, spa, and daily walks, all with care
            and dedication.
          </p>
        </div>
      </section>

      {/* WHY CHOOSE KLYZEN PAWTNER */}
      <section className="pawtner-section pawtner-highlights">
        <h2>Why Choose Klyzen Pawtner</h2>
        <div className="highlights-grid">
          {highlights.map((item, idx) => (
            <div key={idx} className="highlight-card paw-animate">
              <span className="highlight-icon">{item.icon}</span>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Grooming Services */}
      <section className="pawtner-section">
        <h2>Pet Grooming Services</h2>
        <p className="pawtner-subtitle">
          Expert grooming with spa-like experience for your pets.
        </p>
        <div className="pawtner-grid">
          {groomingServices.map((service, idx) => (
            <div key={idx} className="pawtner-card paw-hover">
              <h3>{service.name}</h3>
              <p className="pawtner-desc">{service.description}</p>
              <p className="pawtner-price">{service.price}</p>
              <p className="pawtner-discounted">{service.discounted}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Pet Walking Services */}
      <section className="pawtner-section pawtner-alt">
        <h2>Pet Walking Services</h2>
        <p className="pawtner-subtitle">
          Safe and fun walking sessions tailored for your pets.
        </p>
        {walkingServices.map((walk, idx) => (
          <div key={idx} className="walking-service paw-hover">
            <h3>{walk.name}</h3>
            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Duration</th>
                    <th>Price</th>
                    <th>Offer Price</th>
                  </tr>
                </thead>
                <tbody>
                  {walk.pricing.map((p, i) => (
                    <tr key={i}>
                      <td>{p.duration}</td>
                      <td>{p.price}</td>
                      <td>{p.discounted}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </section>

      {/* CTA */}
      <section className="pawtner-cta">
        <h2>Book Premium Services for Your Pet</h2>
        <p>
          Ensure your pet enjoys the care and attention they deserve — from
          grooming to daily walks.
        </p>
        <a href="/contact" className="cta-btn paw-hover-btn">
          Book Now
        </a>
      </section>

      <Footer />
    </>
  );
}

export default KlyzenPawtner;
